import React from 'react';
import '../home/Home.css';

export default function LeftGame({ setStage, leaderboard, money, setMoney, name }) {
  // Determine which place user finished in
  function determinePlace() {
    // Find index of user
    const idx = leaderboard.map((leader) => {
      return leader.name;
    }).indexOf(name) + 1;

    // Case 0: all teens end with th so just do between 4th and 20th
    if (idx >= 4 && idx <= 20) {
      return idx.toString() + 'th';
    }
    // Case 1: st
    if (idx % 10 === 1) {
      return idx.toString() + 'st';
    }
    // Case 2: nd
    if (idx % 10 === 2) {
      return idx.toString() + 'nd';
    }
    // Case 3: rd
    if (idx % 10 === 3) {
      return idx.toString() + 'rd';
    }
    // Case 4: everything else is th
    return idx.toString() + 'th';
  }

  return (
    <div className='home-container'>
      <div className='home-center'>
        <div className='gameover-content'>
          <h1>
            Thank you for playing <span className='black'>493</span>
            <span className='red'>jack</span>
          </h1>
          <h2>
            You finished the game in {determinePlace()} place with <span className='green'>${money}</span>.
          </h2>

          <div className='rules-scroll-sm'>
            <ol>
              {leaderboard.map(leader =>
                <li>
                  {leader.name}<span className='align-right'>${leader.money}</span>
                </li>
              )}
            </ol>
          </div>

          <button className='home-rules' onClick={() => {setStage('game'); setMoney(100);}}>
            <i className='fa fa-undo'></i> Play again
          </button>
          <button className='home-board' onClick={() => {setStage('home'); setMoney(100);}}>
            <i className='fa fa-home'></i> Return to home
          </button>
        </div>
      </div>
    </div>
  );
}
